module.exports = __webpack_public_path__ + "static/14-026137ae69eb4b0f0ebd3a85312cd245.jpg";